// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { FarfieldModule } from "modules/workflows/Analysis/Farfield/FarfieldModule";

@autoinject
export class FarfieldSettingsModal extends SettingsModal<FarfieldModule> {}
